import { Modal, Button, Form, Row, Col } from "react-bootstrap";
import { useEffect, useState } from "react";
import Select from "react-select";
import { toast, Bounce } from "react-toastify";

const backendUrl = process.env.REACT_APP_BACKEND_URL;

interface Props {
  show: boolean;
  onHide: () => void;
  onSuccess: () => void;
  supplier: any;
}

const wilayaOptions = [
  { value: "Adrar", label: "01 - Adrar" },
  { value: "Chlef", label: "02 - Chlef" },
  { value: "Laghouat", label: "03 - Laghouat" },
  { value: "Oum El Bouaghi", label: "04 - Oum El Bouaghi" },
  { value: "Batna", label: "05 - Batna" },
  { value: "Bejaia", label: "06 - Bejaia" },
  { value: "Biskra", label: "07 - Biskra" },
  { value: "Bechar", label: "08 - Bechar" },
  { value: "Blida", label: "09 - Blida" },
  { value: "Bouira", label: "10 - Bouira" },
  { value: "Tamanrasset", label: "11 - Tamanrasset" },
  { value: "Tebessa", label: "12 - Tebessa" },
  { value: "Tlemcen", label: "13 - Tlemcen" },
  { value: "Tiaret", label: "14 - Tiaret" },
  { value: "Tizi Ouzou", label: "15 - Tizi Ouzou" },
  { value: "Alger", label: "16 - Alger" },
  { value: "Djelfa", label: "17 - Djelfa" },
  { value: "Jijel", label: "18 - Jijel" },
  { value: "Setif", label: "19 - Setif" },
  { value: "Saida", label: "20 - Saida" },
  { value: "Skikda", label: "21 - Skikda" },
  { value: "Sidi Bel Abbes", label: "22 - Sidi Bel Abbes" },
  { value: "Annaba", label: "23 - Annaba" },
  { value: "Guelma", label: "24 - Guelma" },
  { value: "Constantine", label: "25 - Constantine" },
  { value: "Medea", label: "26 - Medea" },
  { value: "Mostaganem", label: "27 - Mostaganem" },
  { value: "M'Sila", label: "28 - M'Sila" },
  { value: "Mascara", label: "29 - Mascara" },
  { value: "Ouargla", label: "30 - Ouargla" },
  { value: "Oran", label: "31 - Oran" },
  { value: "El Bayadh", label: "32 - El Bayadh" },
  { value: "Illizi", label: "33 - Illizi" },
  { value: "Bordj Bou Arreridj", label: "34 - Bordj Bou Arreridj" },
  { value: "Boumerdes", label: "35 - Boumerdes" },
  { value: "El Tarf", label: "36 - El Tarf" },
  { value: "Tindouf", label: "37 - Tindouf" },
  { value: "Tissemsilt", label: "38 - Tissemsilt" },
  { value: "El Oued", label: "39 - El Oued" },
  { value: "Khenchela", label: "40 - Khenchela" },
  { value: "Souk Ahras", label: "41 - Souk Ahras" },
  { value: "Tipaza", label: "42 - Tipaza" },
  { value: "Mila", label: "43 - Mila" },
  { value: "Ain Defla", label: "44 - Ain Defla" },
  { value: "Naama", label: "45 - Naama" },
  { value: "Ain Temouchent", label: "46 - Ain Temouchent" },
  { value: "Ghardaia", label: "47 - Ghardaia" },
  { value: "Relizane", label: "48 - Relizane" },
  { value: "Timimoun", label: "49 - Timimoun" },
  { value: "Bordj Badji Mokhtar", label: "50 - Bordj Badji Mokhtar" },
  { value: "Ouled Djellal", label: "51 - Ouled Djellal" },
  { value: "Beni Abbes", label: "52 - Beni Abbes" },
  { value: "In Salah", label: "53 - In Salah" },
  { value: "In Guezzam", label: "54 - In Guezzam" },
  { value: "Touggourt", label: "55 - Touggourt" },
  { value: "Djanet", label: "56 - Djanet" },
  { value: "El M'Ghair", label: "57 - El M'Ghair" },
  { value: "El Meniaa", label: "58 - El Meniaa" },
];

const textOnlyFields = ["legal_name", "trade_name", "wilaya"] as const;
const numberOnlyFields = [
  "phone",
  "rc_number",
  "nif",
  "nis",
  "workforce_total",
] as const;

export default function EditSupplierModal({
  show,
  onHide,
  onSuccess,
  supplier: supplierProp,
}: Props) {
  const [supplier, setSupplier] = useState({
    id_supplier: "",
    legal_name: "",
    email: "",
    phone: "",
    trade_name: "",
    rc_number: "",
    nif: "",
    nis: "",
    address: "",
    wilaya: "",
    website: "",
    workforce_total: "",
    industrial_status: "active",
  });

  useEffect(() => {
    if (supplierProp) {
      setSupplier({
        id_supplier: supplierProp.id_supplier || "",
        legal_name: supplierProp.legal_name || "",
        email: supplierProp.email || "",
        phone: String(supplierProp.phone || ""),
        trade_name: supplierProp.trade_name || "",
        rc_number: String(supplierProp.rc_number || ""),
        nif: String(supplierProp.nif || ""),
        nis: String(supplierProp.nis || ""),
        address: supplierProp.address || "",
        wilaya: supplierProp.wilaya || "",
        website: supplierProp.website || "",
        workforce_total: String(supplierProp.workforce_total || ""),
        industrial_status: supplierProp.industrial_status || "active",
      });
    }
  }, [supplierProp]);

  const sanitizeText = (value: string) =>
    value.replace(/[^a-zA-ZÀ-ÿ\s'-]/g, "");

  const sanitizeNumber = (value: string) => value.replace(/\D/g, "");
  const handleChange = (e: any) => {
    const { name, value } = e.target;

    let nextValue = value;

    if (textOnlyFields.includes(name)) {
      nextValue = sanitizeText(value);
    }

    if (numberOnlyFields.includes(name)) {
      nextValue = sanitizeNumber(value);
    }

    setSupplier((prev: any) => ({
      ...prev,
      [name]: nextValue,
    }));
  };

  const handleWilayaChange = (
    selected: { value: string; label: string } | null,
  ) => {
    setSupplier((prev) => ({
      ...prev,
      wilaya: selected?.value || "",
    }));
  };

  const handleUpdate = async () => {
    try {
      const res = await fetch(`${backendUrl}/api/update`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          ...supplier,
          workforce_total: Number(supplier.workforce_total || 0),
          geo_lat: null,
          geo_lng: null,
          maturity_score: 0,
        }),
      });

      if (!res.ok) {
        const errorText = await res.text();
        toast.error("Error: " + errorText, { transition: Bounce });
        return;
      }

      toast.success("Supplier updated", { transition: Bounce });
      onHide();
      onSuccess();
    } catch (error) {
      console.error(error);
      toast.error("Error updating supplier", { transition: Bounce });
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered size="xl">
      <Modal.Header closeButton>
        <Modal.Title>Edit Supplier</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form>
          <Row>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Legal Name</Form.Label>
                <Form.Control
                  name="legal_name"
                  value={supplier.legal_name}
                  onChange={handleChange}
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Email</Form.Label>
                <Form.Control
                  name="email"
                  type="email"
                  value={supplier.email}
                  onChange={handleChange}
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Phone</Form.Label>
                <Form.Control
                  name="phone"
                  value={supplier.phone}
                  onChange={handleChange}
                  inputMode="numeric"
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Trade Name</Form.Label>
                <Form.Control
                  name="trade_name"
                  value={supplier.trade_name}
                  onChange={handleChange}
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>RC</Form.Label>
                <Form.Control
                  name="rc_number"
                  value={supplier.rc_number}
                  onChange={handleChange}
                  inputMode="numeric"
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Status</Form.Label>
                <Form.Select
                  name="industrial_status"
                  value={supplier.industrial_status}
                  onChange={handleChange}
                >
                  <option value="active">Active</option>
                  <option value="inactive">Inactive</option>
                  <option value="incomplete">Incomplete</option>
                </Form.Select>
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>NIF</Form.Label>
                <Form.Control
                  name="nif"
                  value={supplier.nif}
                  onChange={handleChange}
                  inputMode="numeric"
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>NIS</Form.Label>
                <Form.Control
                  name="nis"
                  value={supplier.nis}
                  onChange={handleChange}
                  inputMode="numeric"
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Address</Form.Label>
                <Form.Control
                  name="address"
                  value={supplier.address}
                  onChange={handleChange}
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Wilaya</Form.Label>
                <Select
                  options={wilayaOptions}
                  value={
                    wilayaOptions.find(
                      (option) => option.value === supplier.wilaya,
                    ) || null
                  }
                  onChange={handleWilayaChange}
                  placeholder="Select wilaya..."
                  isSearchable
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Website</Form.Label>
                <Form.Control
                  name="website"
                  value={supplier.website}
                  onChange={handleChange}
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Workforce</Form.Label>
                <Form.Control
                  name="workforce_total"
                  value={supplier.workforce_total}
                  onChange={handleChange}
                  inputMode="numeric"
                />
              </Form.Group>
            </Col>
          </Row>
        </Form>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Cancel
        </Button>

        <Button variant="warning" onClick={handleUpdate}>
          Update
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
